import { ReactNode } from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';
import { Form, Formik } from 'formik';

import { DeleteIconSVG } from 'src/assets/images/delete-icon';
import { SaveIconPNG } from 'src/assets/images/save-icon';

import { CustomInput } from '../CustomInput';

interface IModalContentProps {
    handleClose: () => void;
    handleAction: () => void;
    header: string;
    message: string;
    buttonText?: string;
    closeModalButtonText?: string;
    isEdit?: boolean;
    isViewModal?: boolean;
    isSubmitModal?: boolean;
    isActionDisabled?: boolean;
    initialValues?: object;
    children?: ReactNode;
    handleFormSubmit?: (values: object) => void;
    isloading?: boolean;
    validationSchema?: object;
}

const ModalContent = ({
    handleClose,
    handleAction,
    header,
    message,
    buttonText,
    closeModalButtonText = 'Cancel',
    isActionDisabled,
    isEdit,
    isViewModal,
    isSubmitModal,
    initialValues,
    children,
    handleFormSubmit,
    isloading = false,
    validationSchema = undefined,
}: IModalContentProps) => {
    return (
        <>
            {isSubmitModal ? (
                <Formik
                    initialValues={initialValues}
                    onSubmit={async (values) => {
                        handleFormSubmit(values);
                    }}
                    validationSchema={validationSchema}
                >
                    {({ errors, handleChange, handleSubmit, values }) => {
                        return (
                            <Form onSubmit={handleSubmit}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '16px',
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: '18px',
                                            fontWeight: 'bold',
                                            color: '#000',
                                        }}
                                    >
                                        {header}
                                    </Typography>
                                    <CustomInput
                                        name="subject"
                                        label="Subject"
                                        placeholder="Enter subject"
                                        onChange={handleChange}
                                        value={values?.subject}
                                        error={errors?.subject}
                                    />
                                    <CustomInput
                                        name="description"
                                        label="Description"
                                        placeholder="Enter description"
                                        onChange={handleChange}
                                        isMultiline
                                        value={values?.description}
                                        error={errors?.description}
                                    />
                                    <Stack
                                        direction="row"
                                        justifyContent="justify-between"
                                        spacing={2}
                                        sx={{ mt: 3 }}
                                    >
                                        <Button
                                            variant="outlined-black"
                                            onClick={handleClose}
                                            fullWidth
                                            sx={{ width: '170px', height: '44px' }}
                                        >
                                            {closeModalButtonText}
                                        </Button>

                                        <Button
                                            variant="main"
                                            fullWidth
                                            sx={{ width: '170px', height: '44px' }}
                                            type="submit"
                                        >
                                            {buttonText}
                                        </Button>
                                    </Stack>
                                </Box>
                            </Form>
                        );
                    }}
                </Formik>
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                    }}
                >
                    {isViewModal ? null : isEdit ? (
                        <Box>
                            <SaveIconPNG />
                        </Box>
                    ) : (
                        <Box>
                            <DeleteIconSVG />
                        </Box>
                    )}
                    <Typography
                        sx={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: '#000',
                        }}
                    >
                        {header}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '14px',
                            color: '#667085',
                            marginBottom: '16px',
                            wordWrap: 'break-word',
                        }}
                    >
                        {message}
                    </Typography>
                    {children}
                    <Stack
                        direction="row"
                        justifyContent={isActionDisabled ? 'center' : 'justify-between'}
                        spacing={2}
                        sx={{ mt: 3 }}
                    >
                        <Button
                            variant="outlined-black"
                            onClick={handleClose}
                            disabled={isloading}
                            fullWidth
                            sx={{ width: '170px', height: '44px' }}
                        >
                            {closeModalButtonText}
                        </Button>
                        {!isActionDisabled && (
                            <Button
                                variant="main"
                                fullWidth
                                sx={{ width: '170px', height: '44px' }}
                                onClick={handleAction}
                                disabled={isloading}
                            >
                                {buttonText}
                            </Button>
                        )}
                    </Stack>
                </Box>
            )}
        </>
    );
};

export default ModalContent;
